<template>
    <basic-container>
      <el-form
        :model="searchForm"
        ref="searchFormRef"
        label-width="100px"
        label-suffix=":"
        v-show="searchBoxFlag"
      >
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="所属车场" prop="spaceId">
              <selectSearch  v-model="searchForm.spaceId" :dicData="spaceIdList" @change="spaceIdChange"></selectSearch>
              <!-- <el-select
                v-model="searchForm.spaceId"
                style="width:100%"
                placeholder="所属车场"
                @change="spaceIdChange"
              >
                <el-option
                  v-for="item in spaceIdList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                </el-option>
              </el-select> -->
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="优惠规则" prop="discountName">
              <el-input
                clearable
                v-model="searchForm.discountName"
                placeholder="优惠规则"
                maxlength="30"
              ></el-input>
            </el-form-item>
          </el-col>
  
       
          
          <el-col :span="12">
            <div style="float:right">
              <el-button type="primary" icon="el-icon-search" @click="searchRecord" size="small">
                搜索
              </el-button>
              <el-button icon="el-icon-delete" @click="searchClear" size="small"> 清空 </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <avue-crud
        :option="option"
        :table-loading="loading"
        :data="data"
        :page.sync="page"
        ref="crud"
        @on-load="onLoad"
        @row-del="rowDel"
        @current-change="currentChange"
        @size-change="sizeChange"
        @refresh-change="onLoad"
        @selection-change="selectionChange"
      >
        <template slot="menuRight">
          <searchFromShow
            :searchBoxFlag.sync="searchBoxFlag"
            :removeHeight="searchHeight"
            :option="option"
            reduceHeight="20"
            :refOption="$refs.crud"
          ></searchFromShow>
        </template>
       
        <template slot="menuLeft">
          <el-button type="primary" icon="el-icon-plus" size="small" @click="addRecord">
            新 增</el-button
          >
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button type="text" size="small" @click="viewRecord(scope.row)">查看 </el-button>
          <!-- <el-button type="text" size="small" @click="editRecord(scope.row)">编辑 </el-button> -->
         
        </template>
      </avue-crud>
      <hr-dialog :title="formTitle" :allowFull="false" width="60%" :visible.sync="addFormVisible">
        <template slot="body">
          <AddForm
            @cancle="recordCancle"
            :model = "formModel"
            v-if="addFormVisible"
            :row="formRow"
            @success="recordSuccess"
            :spaceId="this.searchForm.spaceId"
          ></AddForm>
        </template>
      </hr-dialog>
  
      
    </basic-container>
  </template>
  <script>

  import { getParkList,carfeerulediscountPage ,carfeerulediscountRemove} from './index.js';
  
  import searchFromShow from '@/components/search-form-show/index';
  import AddForm from './carmonthRuleForm.vue';
  export default {
    components: { searchFromShow, AddForm },
    data() {
      return {
        formRow:{},
        formModel:'add',
        spaceStatusData:[
            {
                dictKey:'0',
                dictValue:'出租',
            },
            {
                dictKey:'1',
                dictValue:'出售',
            },
            {
                dictKey:'2',
                dictValue:'空闲',
            },
        ],
        isDoubleData:[
            {
                dictKey:'0',
                dictValue:'否',
            },
            {
                dictKey:'1',
                dictValue:'是',
            },
            
        ],
        printVisible: false,
        addFormVisible: false,
        addFormVisible: false,
        formTitle: '编辑',
       
        formRow: {},
        searchForm: {
          discountName:'',
          carFeeRuleName:'',
          spaceId: '',
          code: '',
          isDouble: '',
          spaceStatus:'',
          personName:'',
          personPhone:'',
          roomName:"",
        },
     
        option: {
        dialogTop: 10,
        height: 'auto',
        sarchShow: true,
        searchMenuSpan: 12,
        calcHeight: 120,
        tip: false,
        indexLabel: '序号',
        border: true,
        index: true,
        viewBtn: false,
        addBtn:false,
        editBtn:false,
        selection: true,
        dialogWidth: '40%',
        dialogClickModal: false,
        column: [
          {
            label: '车场名称',
            type: 'tree',
            prop: 'spaceId',
            labelWidth: 120,
            searchLabelWidth: 100,
            searchValue: '',
            span: 24,
          
            searchClearable: false,
            // editDisplay: false,
            // viewDisplay: false,
            cell: true,
            props: {
              label: 'title',
              value: 'key',
            },
            rules: [
              {
                required: true,
                message: '请输入车场名称',
              },
            ],
            dicUrl: '/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode/v2?id=0',
            change: (value, column) => {
              // this.generateRemark();
              console.log(value, column);
              this.query.spaceId = value;
            },
          },
          {
            label: '优惠名称',
            labelWidth: 120,
            searchLabelWidth: 100,
            prop: 'discountName',
           
          },
          {
            label: '套餐类型',
            labelWidth: 120,
            searchLabelWidth: 100,
            prop: 'packageType',
            dicUrl: '/api/blade-system/dict/dictionary?code=package_type',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'string',
          },
          {
            label: '收费规则',
          
            labelWidth: 120,
          
           
            prop: 'carFeeRuleName',
            // search: true,
           
          },
         
          {
            label: '缴费期数(月)',
            prop: 'payPeriods',
            labelWidth: 120,
            type: 'number',
           
           
          },

          {
            label: '减免类型',
            type: 'radio',
            labelWidth: 120,
            span: 24,
            // dicUrl: '/api/blade-system/dict/dictionary?code=car_type_v2',
            dicData: [
              { name: '减免月份', id: 1 },
              { name: '减免固定金额', id: 2 },
              { name: '优惠折扣', id: 3 },
            ],
            props: {
              label: 'name',
              value: 'id',
            },
            dataType: 'number',
            prop: 'discountType',
            // search: true,
            rules: [
              {
                required: true,
                message: '请输入减免类型',
              },
            ],
            change: ({ value, column }) => {
              this.generateRemark();
            },
          },

          {
            label: '减免',
            prop: 'discountNumber',
            
          },

          {
            label: '备注',
            labelWidth: 120,
            prop: 'remark',
           
          },
         
        ],
      },
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0,
        },
        loading: false,
        searchBoxFlag: true,
        searchHeight: '',
        selectionList: [],
        recordIds: [],
        canteenList: [],
      };
    },
    created() {
      this.initData();
    },
    mounted() {
      this.calcHeight();
    },
    watch:{
    '$route.path':function(newVal,oldVal){
     
     if(newVal === '/v4ward/carv2/carMaster/carMonthCutRule'){
        this.$refs.crud.$refs.table.doLayout()
     }
    }
  },
    methods: {
      
      recordCancle() {
        this.addFormVisible = false;
      },
      recordSuccess() {
        this.addFormVisible = false;
  
        this.onLoad();
      },
      viewRecord(row) {
        this.formTitle = '查看';
        this.formRow = row;
  
        this.formModel = 'view';
        this.addFormVisible = true;
      },
      
      addRecord() {
        this.formTitle = '新增';
        this.formModel = 'add';
        this.addFormVisible = true;
       
     
      },
      editRecord(row) {
        this.formTitle = '编辑';
        this.formRow = row;
  
        this.formModel = 'edit';
        this.addFormVisible = true;
      },
     
      spaceIdChange(spaceId) {
        this.tool.clearObject(this.searchForm, 'spaceId');
       
      },
      searchRecord() {
        this.page.currentPage = 1;
  
        this.onLoad();
      },
      searchClear() {
        this.tool.clearObject(this.searchForm, 'spaceId');
      },
      rowDel(row) {
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return carfeerulediscountRemove({ids:row.id});
          })
          .then(() => {
            this.onLoad(this.page);
            this.$message({
              type: "success",
              message: "操作成功!"
            });
          });
      },
      calcHeight() {
        this.searchHeight = this.$refs.searchFormRef.$el.clientHeight;
        this.option.height = this.bodyHeight - this.searchHeight - 279 - 20;
      },
      async initData() {
        await getParkList().then((res) => {
          this.spaceIdList = res.data;
          if (this.spaceIdList.length > 0) {
            this.$set(this.searchForm, 'spaceId', this.spaceIdList[0].id);
            this.onLoad();
          }
        });
        
      },
  
      onLoad() {
        if (this.searchForm.spaceId != '') {
          this.loading = true;
  
          carfeerulediscountPage(
            Object.assign(
              {},
              { current: this.page.currentPage, size: this.page.pageSize },
              this.searchForm
            )
          )
            .then(({ data }) => {
              this.data = data.records;
              this.page.total = data.total;
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
        }
      },
    },
  };
  </script>
  
  <style scoped>
  ::v-deep .avue-crud__right {
    display: flex;
  }
  /deep/ .el-drawer__body {
    overflow: scroll !important;
  }
  ::v-deep .avue-crud .el-form-item {
    display: block;
  }
  
  .money {
    text-align: right;
  }
  .txtOver {
    display: -webkit-box;
    overflow: hidden; /*超出隐藏*/
    text-overflow: ellipsis; /*隐藏后添加省略号*/
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  </style>
  <style>
  #alarmRule > div > div.el-dialog__body {
    height: calc(100% - 100px);
  }
  </style>
  